import { API_CONFIG } from '@/config/api';
import { apiFetch } from '@/lib/apiFetch';

export interface InstrumentInfo {
  id?: number;
  created_at?: string | null;
  updated_at?: string | null;
  symbol: string;
  inst_id: string;
  inst_id_code: number;
  exchange: string;
  status: string;
  exp_time: string;
  base_asset: string;
  quote_asset: string;
  symbol_type?: string;
  lot_sz: number;
  min_lot_sz: number;
  min_usd_sz: number;
  ct_val: number;
  max_mkt_sz: number;
  funding_interval: number;
  upper_funding_rate: number;
  lower_funding_rate: number;
}

interface InstrumentInfoResponse {
  success: boolean;
  message: string;
  data?: InstrumentInfo[];
}

export async function getInstrumentById(instId: string, exchange: string): Promise<InstrumentInfo | null> {
  const q = new URLSearchParams({
    exchange,
    status_filter: 'live',
  });
  const url = `${API_CONFIG.INSTRUMENTS_PATH_PREFIX}/instruments/${encodeURIComponent(instId)}?${q.toString()}`;
  const res = await apiFetch(url);
  if (res.status === 404) return null;
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`instruments ${res.status}: ${text || res.statusText}`);
  }
  const payload = (await res.json()) as InstrumentInfoResponse;
  const first = payload.data?.[0];
  return first ?? null;
}
